import React, { useMemo } from 'react'
import { Box, Grid, LinearProgress, Stack } from '@mui/material'
import NormalText from 'common/Typography/NormalText'
import { format, fromUnixTime } from 'date-fns'
import { GetAllInactiveAndTerminatedOtpackUserPlansDetailsType } from 'types/api/faber/oneTimePack.type'

interface Props {
  terminatedUserPlan?: GetAllInactiveAndTerminatedOtpackUserPlansDetailsType[]
}
export default function TerminatedPlanHistory({ terminatedUserPlan }: Props) {
  const getAllTerminatedOtpackUserPlans = useMemo(() => {
    if (terminatedUserPlan) {
      const getAllPlans = terminatedUserPlan.map((item) => (
        <Grid
          key={`inactive-terminated-${item.createdAt}+`}
          container
          sx={{
            justifyContent: 'space-between'
          }}
        >
          <Grid item xs={2.5}>
            <NormalText>{item.packageName}</NormalText>
          </Grid>
          <Grid item xs={3}>
            <Stack flexDirection={'row'} sx={{ alignItems: 'center' }}>
              <Box sx={{ width: '40%', px: 1 }}>
                <LinearProgress
                  color='primary'
                  variant='determinate'
                  value={0}
                />
              </Box>
              <Box sx={{ minWidth: '20%' }}>
                <NormalText variant='body3' sx={{ alignItems: 'center' }}>
                  0/{item.packageDataAllowed} GB
                </NormalText>
              </Box>
            </Stack>
          </Grid>
          <Grid item xs={3}>
            <NormalText theme='muted'>
              {format(fromUnixTime(item.updatedAt / 1000), 'dd MMM yyyy HH:mm')}
            </NormalText>
          </Grid>
          <Grid item xs={2}>
            {' '}
            <NormalText theme='muted'>{item.planStatus}</NormalText>
          </Grid>
          <Grid item xs={1.5}>
            <NormalText theme='muted'>
              {' '}
              {item.packageValidityInDays} days{' '}
            </NormalText>
          </Grid>
        </Grid>
      ))
      return getAllPlans
    }
  }, [terminatedUserPlan])

  return (
    <>
      <Stack
        flexDirection={'row'}
        sx={{ justifyContent: 'center', p: '0 24px ' }}
      >
        <Grid container justifyContent='space-between'>
          <Grid item xs={2.5}>
            <NormalText theme='muted'>Plan</NormalText>
          </Grid>
          <Grid item xs={3}>
            <NormalText theme='muted'>Data Usage</NormalText>
          </Grid>
          <Grid item xs={3}>
            <NormalText theme='muted'>Purchased</NormalText>{' '}
          </Grid>
          <Grid item xs={2}>
            <NormalText theme='muted'>Status</NormalText>{' '}
          </Grid>
          <Grid item xs={1.5}>
            <NormalText theme='muted'>Validity</NormalText>{' '}
          </Grid>
          {getAllTerminatedOtpackUserPlans}
        </Grid>
      </Stack>
    </>
  )
}
